import { Drawer, Table, Tag, Icon, Divider, Tooltip } from "antd";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";

let dateFormat = localStorage.getItem('company-details')
    ? JSON.parse(localStorage.getItem('company-details')).dateFormat
    : 'DD.MM.YYYY';

class AppointmentDetails extends React.Component {
    state = {
        visible: true,
        loading: false
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 300);
    }

    render() {
        let appointments = this.props.appointments || { total: 0, data: [] };
        let { total, data } = appointments;

        const column = [
            {
                title: "Client & Subject",
                key: "client",
                width: "25%",
                render: (_, record) => (
                    <div style={{ padding: '4px 0' }}>
                        <div style={{ fontWeight: 700, color: "#1a3353", fontSize: '14px' }}>
                            {record.name || "Unknown Client"}
                        </div>
                        <div style={{ fontSize: '12px', color: "#1890ff", marginTop: 2 }}>
                            {record.subject || "No Subject"}
                        </div>
                    </div>
                ),
            },
            {
                title: "Meeting Details",
                key: "details",
                render: (_, record) => (
                    <div style={{ fontSize: '13px' }}>
                        <div>
                            <Icon type="environment" style={{ color: '#ff4d4f', marginRight: 8 }} />
                            {record.location || "Online / Not Set"}
                        </div>
                        <div style={{ marginTop: 4, color: '#555' }}>
                            <Icon type="phone" style={{ color: '#52c41a', marginRight: 8 }} />
                            {record.phoneNo || "N/A"}
                        </div>
                    </div>
                ),
            },
            {
                title: "Schedule",
                key: "schedule",
                render: (_, record) => (
                    <div>
                        <div style={{ fontWeight: 600, color: '#2d3436' }}>
                            <Icon type="calendar" style={{ marginRight: 8, color: '#722ed1' }} />
                            {record.startDate ? moment(record.startDate).format(dateFormat) : "-"}
                        </div>
                        <div style={{ fontSize: '12px', color: '#888', paddingLeft: '22px' }}>
                            <Icon type="clock-circle" style={{ marginRight: 4 }} />
                            {record.startTime || "TBD"}
                        </div>
                    </div>
                ),
            },
            {
                title: "Attendees",
                dataIndex: "attendees",
                key: "attendees",
                render: (attendees) => {
                    if (!attendees || attendees.length === 0) return <Tag>Solo</Tag>;
                    return (
                        <Tooltip title={attendees.join(", ")}>
                            <Tag color="purple" style={{ borderRadius: '4px' }}>
                                <Icon type="team" style={{ marginRight: 4 }} />
                                {attendees.length} Person(s)
                            </Tag>
                        </Tooltip>
                    );
                }
            },
            {
                title: "Organizer",
                key: "created",
                align: 'right',
                render: (_, record) => {
                    const creator = record.createdByUser && record.createdByUser.name ? record.createdByUser.name : "System";
                    const createTime = record.createdByUser && record.createdByUser.time
                        ? moment(record.createdByUser.time).format("DD MMM, HH:mm")
                        : "";

                    return (
                        <div style={{ textAlign: 'right' }}>
                            <div style={{ fontWeight: 600, color: '#444' }}>{creator}</div>
                            <div style={{ fontSize: '11px', color: '#aaa' }}>{createTime}</div>
                        </div>
                    );
                },
            }
        ];

        // ... inside your render() method
        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '95%' }}>
                        <span>
                            <Icon type="schedule" style={{ marginRight: 10 }} />
                            Today's Appointments
                        </span>
                        <Tag
                            style={{
                                backgroundColor: '#d97706',
                                color: '#fff',
                                fontWeight: 700,
                                border: 'none',
                                borderRadius: '4px'
                            }}
                        >
                            {total} SLOTS
                        </Tag>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={this.state.visible}
                width={1100}
                className="modern-drawer-appointment" // This class triggers the CSS above
            >
                <Table
                    dataSource={data}
                    columns={column}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ["10", "20", "50"],
                    }}
                    loading={this.state.loading}
                    rowKey={(record, index) => index}
                />
            </Drawer>
        );
    }
}

const mapDispatchToProps = dispatch => ({ dispatch });
export default connect(null, mapDispatchToProps)(AppointmentDetails);